module.exports = __webpack_public_path__ + "static/media/pic.27845dc5.jpeg";